import React from 'react';
import './Components.css';

const StockAlerts = ({ medicines }) => {
  // Low stock based on each medicine's reorderLevel (default 10 if not set)
  const lowStock = medicines.filter(med => med.stock <= (med.reorderLevel || 10));

  const expiringSoon = medicines.filter(med => {
    const expiryDate = new Date(med.expiryDate);
    const today = new Date();
    const daysLeft = (expiryDate - today) / (1000 * 3600 * 24);
    return daysLeft <= 30 && daysLeft > 0;
  });

  return (
    <div className="card alerts-card">
      <h2>⚠️ Stock Alerts</h2>
      <div className="alert-section">
        <h3>Low Stock (Below Reorder Level)</h3>
        {lowStock.length === 0 ? (
          <p className="good">✅ All stocks are sufficient</p>
        ) : (
          <ul>
            {lowStock.map(med => (
              <li key={med._id}>
                {med.name} – only {med.stock} left (Reorder at {med.reorderLevel || 10})
              </li>
            ))}
          </ul>
        )}
      </div>
      <div className="alert-section">
        <h3>Expiring within 30 days</h3>
        {expiringSoon.length === 0 ? (
          <p className="good">✅ No medicines expiring soon</p>
        ) : (
          <ul>
            {expiringSoon.map(med => (
              <li key={med._id}>{med.name} – expires {new Date(med.expiryDate).toLocaleDateString()}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default StockAlerts;